import { Room } from '../room-booking/room.model';

/**
 * Schedule action model
 */
export class ScheduleAction {
    public iri: string;
    public startTime: string | Date;
    public endTime: string | Date;
    public room: Room;
    constructor(json?) {
        if (json != null) {
            this.iri = json['@id'];
            this.startTime = json.startTime;
            this.endTime = json.endTime;
            this.room = json.room;
        }
    }
}
